
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
//   Flits(document).on('Flits:Navigation:Loaded', function(event){
//     var settings = event.detail.settings;
//     var obj = {
//       title: 'My Wishlist',
//       url:'/pages/wish-list',
//       target:1,
//       badge: null,
//       icon: '<svg class="custom-wsl-svg" style="fill:none;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>',
//       isShow: 1,
//       loader:null,
//       body_html: ''
//     }
//     settings.navs.splice(4, 0, obj);
//   });
  
  
   // WISHLIST
 
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){
    var data = event.detail.settings;
    var domSelectores  = data.domSelector;
    var login_form = ['form[action="'+window.flitsObjects.global.route_login_url+'"]:not(#customer_login_guest)', !0];
    var register_form = ['form[action="'+window.flitsObjects.global.route_register_url+'"]', !0];
    domSelectores.push(login_form,register_form);
  });
  
 Flits(document).on('Flits:wishlistButton:Loaded', function(event){
   setTimeout(function(){
     if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
       let collectionBtn = Flits('.flits-wishlist-colection');
       parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
         Flits(collectionBtn).show(),
         Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
     }
   }, 1000);
 });
  Flits(document).on('QuickviewLoaded', function(event){
    var productHandle = event.detail;
    var is_product_added = Flits.isProductAddedInWishlist(productHandle);
    setTimeout(function(){
      var wishBtn = Flits('.ajax-quickview .flits-wishlist-button-style .flits-wls-button');
      if(is_product_added){
        wishBtn.removeClass("flits-wls-inactive");
        wishBtn.addClass("flits-wls-active");
        wishBtn.attr('data-tippy-content',Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        //       wishlist_btn.animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
      }else{
        wishBtn.removeClass("flits-wls-active");
        wishBtn.addClass("flits-wls-inactive");
        wishBtn.attr('data-tippy-content',Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'));
        //       wishlist_btn.animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'));
      }
      Flits('.ajax-quickview .groups-btn .flits-wishlist-button-style').removeAttr('id');
      Flits('.ajax-quickview .groups-btn .flits-wishlist-button-style').css('display','flex');
    }, 500);
  });
  Flits(document).on('productsTabClick', function(){
  	setTimeout(function(){
     if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
       let collectionBtn = Flits('.flits-wishlist-colection');
       parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
         Flits(collectionBtn).show(),
         Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
     }
   }, 1000);
  });
  
  
  function addToCartCustom(params){
     flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: !1 }),
       Flits.ajax({ type: "POST", url: "/cart/add.js", data: params, dataType: "json" })
     .done(function (resp) {

       Flits.setLocalStorage("openCart", "true");
       setTimeout(function(){
         Flits.flitsSnackbarHide();
         Flits.getJSON('/cart.js', function(cart) {
 //      alert('There are now ' + cart.item_count + ' items in the cart.');
           Flits(".cart-count-bubble").text(cart.item_count);
         });
       },3000);
       location.reload();
     })
     .fail(function (resp) {
       flitsSnackbar.show({ text: resp.responseJSON.description, pos: "bottom-center", showAction: !1, customClass: "flits-alert-error" });
     })
     .always(function () {});
   }


    Flits(document).on("click", ".flits-add-to-cart", function (event) {
     event.preventDefault();
     event.stopPropagation();
     event.stopImmediatePropagation();
     let el = Flits(this);
     let quantity = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').val());
     let maxLimit = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').attr("max"));
     let id = Flits(el).parents(".flits-product-card").find(".flits-variant-select").val();
     (Flits(el).attr("data-flits-add-action-from") == "wishlist" || Flits(el).attr("data-flits-add-action-from") == "recentlyView") &&
       Flits(el).parents(".flits-product-card").find(".flits-variant-select").val() == "" &&
       (id = Flits(el).parents(".flits-product-card").find(".flits-variant-select option:nth-child(2)").val());
     let interval = 0;
     cartOrder[id] &&
       quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit &&
       ((quantity = maxLimit - parseInt(cartOrder[id].cart_quantity)),
        quantity == 0 ? (quantity = maxLimit) : quantity,
        (interval = 3000),
        flitsSnackbar.show({ text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" }));
     let data = "id=" + id + "&quantity=" + quantity;
     setTimeout(function () {
      addToCartCustom(data);
     }, interval);
     return false;
   });




   Flits(document).on("click", ".flits-reorder-btn", function (event) {
     event.preventDefault();
     event.stopPropagation();
     event.stopImmediatePropagation();
     let items = flitsOrder[Flits(this).attr("data-target")];
     let params = {};
     let noItem = 0;
     let soldOutItem = 0;
     if (((params.items = []), items.length > 0)) {
       for (let i = 0; items.length > i; i++) {
         let item = items[i];
         item.item_variant_id
         ? item.available == "true"
         ? (parseInt(item.inventory_quantity) <= parseInt(item.quantity)
            ? cartOrder[item.variant_id] &&
            (parseInt(item.inventory_quantity) > parseInt(cartOrder[item.variant_id].cart_quantity)
             ? (item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity))
             : (item.quantity = parseInt(item.inventory_quantity)),
             flitsSnackbar.show({
           text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
           pos: "bottom-center",
           showAction: !1,
           customClass: "flits-alert-default",
         }))
            : cartOrder[item.variant_id] &&
            parseInt(item.inventory_quantity) <= parseInt(cartOrder[item.variant_id].cart_quantity) + parseInt(item.quantity) &&
            ((item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity)),
             flitsSnackbar.show({
           text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
           pos: "bottom-center",
           showAction: !1,
           customClass: "flits-alert-default",
         })),
            params.items.push({ id: item.variant_id, quantity: item.quantity }))
         : soldOutItem++
         : noItem++;
       }
       noItem == 1
       ? flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_unavailable", "One of the products is unavailable"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" })
       : noItem > 1 &&
         flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_unavailable", "Some of the products are unavailable"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" }),
         soldOutItem == 1
       ? setTimeout(
         function () {
           flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_sold_out", "One of the products is sold out."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" });
         },
         noItem > 0 ? 1500 : 0
       )
       : soldOutItem > 1 &&
         setTimeout(
         function () {
           flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_sold_out", "Some of the products are sold out"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" });
         },
         noItem > 0 ? 1500 : 0
       ),
         Flits.dispatchEvent("Flits:order:BeforeReOrder", { params: params }),
         setTimeout(
         function () {
           addToCartCustom(params);
         },
         soldOutItem > 0 || noItem > 0 ? 2500 : 1000
       );
     }
   });

   Flits(document).on('Flits:topOrder:Loaded', function(event){
     Flits(".flits-filter-dropbtn ").on("click", function () {
       Flits(".flits-dropdown-content").css("display","block");
     });
   });



   Flits(document).on('Flits:topOrder:Loaded', function(event){
     Flits(".flits-filter-dropbtn").on('click', function(){
       Flits(".flits-top-order-list-div .flits-dropdown .flits-dropdown-content").slideToggle();
 //       var drpdwn = document.querySelector(".flits-dropdown-content");
 //       var isClassAdded = drpdwn.classList.contains("flits-custom-d");
 //       if(isClassAdded){
 //         Flits(".flits-filter-dropbtn  .flits-dropdown-content").removeClass("flits-custom-d");
 //       } else{
 //         Flits(".flits-dropdown-content").addClass("flits-custom-d");
 //       }

     });
   });
  window.addEventListener('locationchange', function(event){
    console.log('change');
  	setTimeout(function(){
     if (Flits.request.page_type == 'collection') {
       let collectionBtn = Flits('.flits-wishlist-colection');
       parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
         Flits(collectionBtn).show(),
         Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
         var grid = Flits('.flits-wishlist-colection:not(.flits-template)');
         Flits(grid).each(function(index,single_grid_item){
           var handle = Flits(single_grid_item).find('.flits-wls-button').attr('data-flits-product-handle');
           if(Flits.isProductAddedInWishlist(handle)){ 
             Flits(single_grid_item).find('.flits-wls-button').removeClass("flits-wls-inactive")
             Flits(single_grid_item).find('.flits-wls-button').addClass("flits-wls-active")
             Flits(single_grid_item).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Added to Wishlist'))
           } else {
             Flits(single_grid_item).find('.flits-wls-button').removeClass("flits-wls-active")
             Flits(single_grid_item).find('.flits-wls-button').addClass("flits-wls-inactive")
             Flits(single_grid_item).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'))
           }
         });
     }
   }, 5000);
    setTimeout(function(){
     if (Flits.request.page_type == 'collection') {
       let collectionBtn = Flits('.flits-wishlist-colection');
       parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
         Flits(collectionBtn).show(),
         Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
         var grid = Flits('.flits-wishlist-colection:not(.flits-template)');
         Flits(grid).each(function(index,single_grid_item){
           var handle = Flits(single_grid_item).find('.flits-wls-button').attr('data-flits-product-handle');
           if(Flits.isProductAddedInWishlist(handle)){ 
             Flits(single_grid_item).find('.flits-wls-button').removeClass("flits-wls-inactive")
             Flits(single_grid_item).find('.flits-wls-button').addClass("flits-wls-active")
             Flits(single_grid_item).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Added to Wishlist'))
           } else {
             Flits(single_grid_item).find('.flits-wls-button').removeClass("flits-wls-active")
             Flits(single_grid_item).find('.flits-wls-button').addClass("flits-wls-inactive")
             Flits(single_grid_item).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'))
           }
         });
     }
   }, 10000);
  });

  var homeAjaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    (-1 !== url.indexOf("collections/all")) && Flits.dispatchEvent("Flits:homeAjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(homeAjaxWishlistViewFunction);
  Flits.addFetchEvents(homeAjaxWishlistViewFunction);

  Flits(document).on("Flits:homeAjaxWishlist", function(){
    setTimeout(function(){
      let collectionBtn = Flits(".flits-wishlist-colection");
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
        Flits(collectionBtn).show(),
        Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
    }, 1000);
    setTimeout(function(){
      Flits('.flits-wishlist-colection').each(function(index,ele){
      	let wishProdHandle = Flits(ele).find('.flits-wls-button').attr('data-flits-product-handle');
        if(Flits.isProductAddedInWishlist(wishProdHandle)){
          Flits(ele).find('.flits-wls-button').removeClass("flits-wls-inactive")
          Flits(ele).find('.flits-wls-button').addClass("flits-wls-active")
          Flits(ele).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'))
        }
      });
    },2000);
  });

  Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){
  
    var data = event.detail;
    
    var el = data.el;
    var parent = data.parent; // parent
    var cloneNode = data.cloneNode; // cloned social login div
    cloneNode.prepend(`<div class="flits-social-login-text"><span class="line-center">${Flits.t('Flits.locals.general.social_login_or_text', 'Or')}</span></div>`)
  });

  Flits.fn.extend({
    appendSocialLoginDivAdded: function(socialLoginBtnGroup, isTrue) {
      var settings = Flits.SocialLogin.settings;
      return this.filter(':not([data-flits="social-login-added"])').each(function(index, el) {
        if (el = Flits(el),
            isTrue && (el.css('display') == 'none'))
          return;
        if (typeof el[0].addEventListener != 'function')
          return;
        var parent = el.parent();
        var cloneNode = socialLoginBtnGroup.clone(!0);
        parent.append(cloneNode),
          el.attr('data-flits', 'social-login-added'),
          parent.attr('data-flits', 'social-login-parent'),
          settings.automaticAppendDivFunction.apply(this, [el, parent, cloneNode]),
          Flits.dispatchEvent('Flits:SocialLoginAutomaticCode:Loaded', {
          el: el,
          parent: parent,
          cloneNode: cloneNode
        });
      }),
        this;
    }
  })

  var  buttonAppendButtons =  function() {
    let selector = Flits.SocialLogin.settings.domSelector;
    let selectorLength = Flits.SocialLogin.settings.domSelector.length;
    let items = Flits.SocialLogin.settings.buttonConfig;
    let socialLoginBtnGroup = Flits('<div />');
    socialLoginBtnGroup.addClass('flits-social-login-btn-grp');
    let socialLoginErrorDiv = Flits('<div />');
    socialLoginErrorDiv.addClass('flits-social-login-error'),
      Flits.each(items, function(index, item) {
      if (Flits.Metafields[item.metafieldName] && item.isDisplay) {
        let btnClone = Flits(Flits.SocialLogin.settings.social_login_button_html);
         btnClone.removeAttr('id');
                    let hrefAttr = btnClone.attr('data-href').replace('proxy_name', Flits.proxy_name).replace('app_id', Flits.app_id).replace('shop_id', Flits.shop_id).replace('shop_token', Flits.token).replace('login_type', item.login_type);
                    btnClone.attr('href', hrefAttr);
                    btnClone.attr('data-flits-provider', index);
                    btnClone.removeAttr('data-href');
                    btnClone.addClass(item.btn_class);
                    btnClone.css('order', item.order);
                    Flits(btnClone).find('.flits-social-login-btn-img').html(item.icon_img);
                    Flits(btnClone).find('.flits-social-login-btn-text').html(item.login_name);
                    socialLoginBtnGroup.append(btnClone)
      }
    });
    let code = Flits('<div />');
    for (code.addClass('flits-social-login-container'),
         code.append(socialLoginBtnGroup),
         code.append(socialLoginErrorDiv),
         i = 0; Flits.SocialLogin.settings.domSelector.length > i; i++)
      Flits.SocialLogin.settings.domSelector,
        Flits(Flits.SocialLogin.settings.domSelector[i][0]).appendSocialLoginDivAdded(code, Flits.SocialLogin.settings.domSelector[i][1]);
  };

 if(Flits.request.page_type !== 'customers/login' && Flits.request.page_type !== 'customers/register'){
    Flits(document).on('Flits:SocialLogin:Loaded', function(event){
    buttonAppendButtons();
  });
 }
 
// FLITS wishlist on collection page filter
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=quick-view'
    (-1 !== url.indexOf('?section_id=') || -1 !== url.indexOf('/actions/accounts')) && Flits.dispatchEvent("Flits:AjaxWishlist", {
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits(".productListing .product-item .flits-wishlist-colection .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist(handle)){ 
           Flits(single_grid_item).animateWishlistButton(wsl_product_count, Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Added to Wishlist'))
        }
      });
    }, 1000);
  });

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){
      let collectionBtn = Flits(".flits-wishlist-colection");
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
        Flits(collectionBtn).show(),
        Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
    }, 1000);
    setTimeout(function(){
      Flits('.flits-wishlist-colection').each(function(index,ele){
      	let wishProdHandle = Flits(ele).find('.flits-wls-button').attr('data-flits-product-handle');
        if(Flits.isProductAddedInWishlist(wishProdHandle)){ 
          Flits(ele).find('.flits-wls-button').removeClass("flits-wls-inactive")
          Flits(ele).find('.flits-wls-button').addClass("flits-wls-active")
          Flits(ele).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'))
        }
      });
    },2000);
  });

   Flits(document).on("Flits:Loaded",function(e){
     if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
   Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
 }
    if(Flits.request.page_type == "customers/account"){
       Flits(".header [href='/pages/wish-list']").attr("href","#wishlist");
       Flits(document).on("click",".header [href='#wishlist']",function(event){
        Flits.navigationFunc("#wishlist")
      })
    } else{
      Flits(".header [href='/pages/wish-list']").attr("href",window.flits_route_account_url+"#wishlist");
      
    } 
 });
}(Flits));


